import { Component } from '@theme/component';

/**
 * Busca do dicionário. Aditiva: o campo nasce escondido no CSS e só aparece quando este
 * componente se registra, então sem JS os termos seguem todos no DOM e indexáveis.
 *
 * Usa `hidden` porque o filtro por letra é CSS (`display`) — assim os dois se somam.
 *
 * @extends {Component<{ input: HTMLInputElement }>}
 */
class GlossaryDictSearch extends Component {
  requiredRefs = ['input'];

  connectedCallback() {
    super.connectedCallback();

    this.dict = this.closest('.gtc-dict');
    if (!this.dict) return;

    this.terms = /** @type {HTMLElement[]} */ ([...this.dict.querySelectorAll('.gtc-term')]);
    this.empty = /** @type {HTMLElement | null} */ (this.dict.querySelector('.gtc-dict-empty'));

    this.dataset.ready = 'true';
    this.refs.input.addEventListener('input', this.#filter);
  }

  disconnectedCallback() {
    this.refs.input?.removeEventListener('input', this.#filter);
    super.disconnectedCallback?.();
  }

  /**
   * Sem acento e sem caixa: buscar "acidificacao" tem que achar "Acidificação".
   *
   * @param {string} value
   * @returns {string}
   */
  #normalize(value) {
    return value
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase();
  }

  #filter = () => {
    const query = this.#normalize(this.refs.input.value.trim());

    for (const term of this.terms) {
      const match = !query || this.#normalize(term.textContent ?? '').includes(query);
      term.hidden = !match;
    }

    // Conta o que está na TELA: `offsetParent` é nulo sob qualquer um dos dois filtros.
    // Contar só o casamento de texto esconderia o aviso com o grid vazio.
    const visible = this.terms.some((term) => term.offsetParent !== null);

    if (this.empty) this.empty.hidden = visible;
  };
}

if (!customElements.get('gtc-dict-search')) {
  customElements.define('gtc-dict-search', GlossaryDictSearch);
}
